import {Box, InputLabel, MenuItem, Select, Tooltip, Typography} from "@mui/material";
import {instrumentColormaps} from "../../utils/colormaps";
import {useTheme} from "@mui/material/styles";
import {memo, useEffect, useState} from "react";

const MhdColorbarChoices = ({ label, value, onChange, disabled, mappings }) => {
  const theme = useTheme()
  const [listVal, setListVal] = useState(null)

  useEffect(() => {
    setListVal(mappings.find(item => item.value === value))
  }, [value])


  return (
    <>
      <InputLabel variant='primary'>
        {label}
      </InputLabel>
      <Select
        value={listVal ? value : ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
      {mappings.map((choice) => (
        <MenuItem
          key={choice.value}
          value={choice.value}
        >
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: 1}}
          >
            <Tooltip title={<Typography fontSize={10}>{choice.label}</Typography>} arrow>
              <img
                src={`${process.env.PUBLIC_URL}/colormaps/${choice.value}.jpg`}
                alt={choice.label}
                style={{ display: 'flex', height: 10, width: "100%"}}
              />
            </Tooltip>
          </Box>
        </MenuItem>
      ))}
      </Select>
    </>
  );
};


export default memo(MhdColorbarChoices);